import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Order } from '../../types';
import { Card } from '../atoms/Card';
import { MockTradingAPI } from '../../services/mockAPI';

export const OrdersPanel: React.FC = () => {
  const { data: orders } = useQuery<Order[]>({
    queryKey: ['orders'],
    queryFn: MockTradingAPI.getOrders,
  });

  return (
    <Card className="p-6" data-testid="orders-panel">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Recent Orders</h2>
      {orders?.length === 0 ? (
        <p className="text-gray-600 dark:text-gray-300">No orders yet</p>
      ) : (
        <div className="space-y-3">
          {orders?.map(order => (
            <div key={order.id} className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div>
                <p className="font-medium text-gray-900 dark:text-white">
                  {order.side.toUpperCase()} {order.quantity} {order.symbol}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  {order.type} • {new Date(order.timestamp).toLocaleString()}
                </p>
              </div>
              <span
                className={`px-2 py-1 text-xs rounded-full ${order.status === 'executed'
                  ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                  : order.status === 'pending'
                    ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
                    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                  }`}
              >
                {order.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};